import { render, staticRenderFns } from "./AttachmentView.vue?vue&type=template&id=06baf346&"
import script from "./AttachmentView.vue?vue&type=script&lang=js&"
export * from "./AttachmentView.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports